import React from "react";
import { Navbar, Nav, Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaUsers, FaList, FaChartBar, FaSignOutAlt, FaSyncAlt } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const PATHS = {
  dashboard: "/admin/partners",
  adminPartners: "/admin/partners",
  adminOrders: "/admin/orders",
  adminAnalytics: "/admin/analytics/overview",
  amocrmSync: "/admin/sync/amocrm",
  partnerOrders: (partnerId) => `/partner/${partnerId}`,
  logout: "/logout",
  login: "/login",
};

const NavbarMenu = () => {
  const { user, isAuthenticated } = useAuth() || {};
  const roleList = Array.isArray(user?.roles)
    ? user.roles.filter(Boolean)
    : user?.role
    ? [user.role]
    : [];
  const normalizedRoles = roleList.map((role) => String(role).toLowerCase());
  const hasRole = (role) => normalizedRoles.includes(role);

  const navLinks = [
    {
      key: "analytics",
      label: "Аналитика",
      icon: FaChartBar,
      to: PATHS.adminAnalytics,
      visible: hasRole("admin") || hasRole("manager"),
    },
    {
      key: "partners",
      label: "Партнёры",
      icon: FaUsers,
      to: PATHS.adminPartners,
      visible: hasRole("admin") || hasRole("manager"),
    },
    {
      key: "orders",
      label: "Все сделки",
      icon: FaList,
      to: PATHS.adminOrders,
      visible: hasRole("admin") || hasRole("manager"),
    },
    {
      key: "amocrm-sync",
      label: "Сверка amoCRM",
      icon: FaSyncAlt,
      to: PATHS.amocrmSync,
      visible: hasRole("admin") || hasRole("manager"),
    },
    user?.partnerUniqueId && {
      key: "partner-orders",
      label: "Мои заказы",
      icon: FaList,
      to: PATHS.partnerOrders(user.partnerUniqueId),
      visible: hasRole("partner"),
    },
  ].filter((link) => link && link.visible);

  const roleLabel = roleList.length ? roleList.join(", ").toUpperCase() : "ГОСТЬ";
  const avatarFallback = roleLabel.slice(0, 1);

  return (
    <Navbar expand="lg" className="navbar-elevated">
      <Container fluid="xl" className="py-2">
        <Navbar.Brand as={Link} to={PATHS.dashboard} className="brand-mark">
          <div className="brand-logo" aria-hidden="true">
            <img src="/logo.png" alt="" role="presentation" />
          </div>
          <div className="brand-meta">
            <span className="brand-eyebrow">Partner Panel</span>
            <strong>Сеть партнёров</strong>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto gap-1">
            {navLinks.map(({ key, label, icon: Icon, to }) => (
              <Nav.Link as={Link} to={to} key={key} className="nav-pill">
                <Icon className="me-1" size={14} /> {label}
              </Nav.Link>
            ))}
          </Nav>

          <div className="navbar-meta ms-lg-3">
            {isAuthenticated ? (
              <>
                <div className="user-chip">
                  <span className="user-avatar" aria-hidden="true">
                    {avatarFallback}
                  </span>
                  <div>
                    <div className="user-label">В сети</div>
                    <div className="user-role">{roleLabel}</div>
                  </div>
                </div>
                <Button
                  as={Link}
                  to={PATHS.logout}
                  variant="outline-danger"
                  className="btn-rounded"
                  aria-label="Выйти из панели"
                >
                  <FaSignOutAlt className="me-1" /> Выйти
                </Button>
              </>
            ) : (
              <Button as={Link} to={PATHS.login} variant="primary" className="btn-rounded">
                Войти
              </Button>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarMenu;
